module.exports = __webpack_public_path__ + "img/NewVehicleIcon.76c5beee.svg";